import { Point2D } from '../../team-apis/otterdam/answers/shape-typings';

export class MouseState {
  containerPoint: Point2D = [0, 0];
}
